module.exports = __webpack_public_path__ + "img/search-zoom-in-1.13a38051.svg";